import dynamic from "next/dynamic";
const AmandaMeetingWizardComponent = dynamic(()=>import("./amanda-meeting-wizard-component"));
import AmandaMeetingWizardConfig from "./amanda-meeting-wizard-config";
import AmandaMeetingWizardAdvancedConfig from "./amanda-meeting-wizard-advanced-config";
export default {
    AmandaMeetingWizardComponent,
    AmandaMeetingWizardConfig,
    AmandaMeetingWizardAdvancedConfig
};
